import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const dt = (s) => new Date(s).toLocaleString('tr-TR');

// İSG: mağaza itirazını görür ve "devam" ya da "iptal" kararı verir; sonuç mağazaya e-posta ile gider
export const StoreObjectionBox = ({ permit, onChanged }) => {
  const [obj, setObj] = useState(permit.store_objection);
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const res = obj.resolution;
  const decide = async (action) => {
    if (action === 'cancel' && !window.confirm('Talep mağaza itirazı üzerine iptal edilecek (geri çekilecek). Emin misiniz?')) return;
    setBusy(true);
    try {
      const { data } = await axios.put(`${API}/work-permits/${permit.id}/store-objection`, { action, note });
      setObj(data.store_objection);
      toast.success(action === 'continue' ? 'Talep devam ediyor; mağazaya bilgi gönderildi' : 'Talep iptal edildi; mağazaya ve firmaya bilgi gönderildi');
      onChanged?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'İşlem yapılamadı');
    } finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-rose-300 bg-rose-50 p-4 text-sm text-rose-800 space-y-2" data-testid="detail-store-objection">
      <p className="font-semibold">Mağaza itirazı var: {permit.store_name} bu talebin bilgisi dahilinde olmadığını bildirdi.</p>
      <p className="text-rose-700">{obj.by} · {dt(obj.at)}{obj.note ? ` — ${obj.note}` : ''}</p>
      {res ? (
        <p className={`rounded-md px-3 py-2 font-medium ${res.action === 'continue' ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-200 text-slate-800'}`} data-testid="detail-store-objection-result">
          {res.action === 'continue' ? 'Değerlendirildi: talep devam ediyor' : 'Talep itiraz üzerine iptal edildi'} · {res.by} · {dt(res.at)}{res.note ? ` — ${res.note}` : ''}
        </p>
      ) : (
        <div className="space-y-2">
          <Textarea value={note} onChange={e => setNote(e.target.value)} rows={2} maxLength={500} placeholder="Mağazaya iletilecek açıklama (isteğe bağlı)" className="bg-white" data-testid="objection-resolve-note" />
          <div className="flex flex-wrap justify-end gap-2">
            <Button size="sm" variant="outline" className="border-emerald-300 bg-white text-emerald-700 hover:bg-emerald-50" disabled={busy} onClick={() => decide('continue')} data-testid="objection-resolve-continue">Talep Devam Etsin</Button>
            <Button size="sm" className="bg-rose-600 hover:bg-rose-700" disabled={busy} onClick={() => decide('cancel')} data-testid="objection-resolve-cancel">Talebi İptal Et</Button>
          </div>
          <p className="text-xs text-rose-600">Verdiğiniz karar mağazaya otomatik e-posta ile bildirilir.</p>
        </div>
      )}
    </div>
  );
};
